import { useResolveTodistuksetTabs } from 'todistukset-ui/src/vtj/components/tab-navigation/use-resolve-todistukset-tabs'
import React from 'react'
import { observer } from 'mobx-react'
import {
  CertificateCount,
  TabLandingPage,
  TabWizard,
  TabListLandingPage,
  TabListWizard,
  TabNavigationContainerLandingPage,
  TabNavigationContainerWizard,
} from 'todistukset-ui/src/vtj/components/tab-navigation/tab-navigation.sc'
import { Text } from 'suomifi-ui-components'

interface TabNavigationProps {
  shouldUseLandingPageStyles?: boolean
}

function TabNavigation(props: TabNavigationProps): React.JSX.Element {
  const { shouldUseLandingPageStyles } = props
  const tabConfigs = useResolveTodistuksetTabs()
  const visibleTabConfigs = tabConfigs.filter((config) => config.isVisible)

  const ContainerComponent = shouldUseLandingPageStyles
    ? TabNavigationContainerLandingPage
    : TabNavigationContainerWizard

  const TabListComponent = shouldUseLandingPageStyles
    ? TabListLandingPage
    : TabListWizard

  const TabComponent = shouldUseLandingPageStyles ? TabLandingPage : TabWizard

  return (
    <ContainerComponent role="navigation">
      <TabListComponent variant="nav" role="tablist">
        {visibleTabConfigs.map((tabConfig) => (
          <TabComponent
            tabIndex={0}
            key={tabConfig.id}
            data-test-id={tabConfig.id}
            to={tabConfig.to}
            $isActive={tabConfig.isActive}
            role={'tab'}
            aria-selected={tabConfig.isActive}
            aria-label={tabConfig.label}
          >
            <Text>{tabConfig.label}</Text>
            {tabConfig.certificateCount !== undefined &&
              tabConfig.certificateCount > 0 && (
                <CertificateCount data-test-id="tab-navigation-certificate-count-indicator">
                  {tabConfig.certificateCount}
                </CertificateCount>
              )}
          </TabComponent>
        ))}
      </TabListComponent>
    </ContainerComponent>
  )
}

export default observer(TabNavigation)
